import { Flex, Text } from "@chakra-ui/layout";
import { Skeleton } from "@chakra-ui/skeleton";
import { FaBuilding } from "react-icons/fa";
import CardDefault from "components/Cards/CardDefault";

interface Card2HorizontalProps {
  title: string;
  description: string;
  subDescription?: string;
  onClick?: any;
  icon?: any;
  bg: string;
  color?: string;
  loading?: boolean;
  right?: any;
  w?: string;
  colorTitle?: string;
  fontSize?: number;
}

function Card2Horizontal({
  title,
  description,
  subDescription,
  onClick,
  icon,
  bg,
  color,
  loading,
  right,
  w,
  colorTitle,
  fontSize = 22,
}: Card2HorizontalProps) {
  return (
    <CardDefault
      flexDir="row"
      justifyContent="center"
      alignItems="center"
      onClick={onClick}
      h="100%"
      w={w}
    >
      {loading ? (
        <Flex flex={1} flexDir={"column"}>
          <Skeleton h="50px" w="50px" rounded={"full"} mb="8px" />
          <Skeleton h="20px" w="160px" mb="8px" />
          <Skeleton h="30px" w="80px" />
        </Flex>
      ) : (
        <>
          <Flex
            flex={1}
            justifyContent="flex-start"
            flexDir="column"
            position="relative"
          >
            <Flex
              w="50px"
              h="50px"
              rounded="50%"
              justifyContent="center"
              alignItems="center"
              bg={bg}
            >
              {!icon ? <FaBuilding fontSize="18px" color={color} /> : icon}
            </Flex>
            <Text fontSize="14px" mt="4px" display="inline-text">
              {description}
              {subDescription ? (
                <Text
                  fontSize="10px"
                  mt="4px"
                  color={"gray.400"}
                  display="inline"
                >
                  {" "}
                  {subDescription}
                </Text>
              ) : null}
            </Text>

            <Text
              fontSize={fontSize}
              fontWeight="bold"
              color={colorTitle ?? "gray.600"}
            >
              {title}
            </Text>

            {right ? (
              <Flex
                position="absolute"
                right={0}
                top="16px"
                alignItems="center"
                justifyContent="center"
              >
                {right}
              </Flex>
            ) : null}
          </Flex>
        </>
      )}
    </CardDefault>
  );
}

export default Card2Horizontal;
